// src/pages/EventRegistration.js

export default function EventRegistration({
  basicValues,
  onBasicChange,
  hasCustomForm,
  customQuestions,
  renderQuestion,
}) {
  return (
    <>
      {/* Basic name/email */}
      <div className="checkout-form-field">
        <label className="checkout-form-label" htmlFor="name">
          Name<span className="checkout-form-required">*</span>
        </label>
        <input
          id="name"
          name="name"
          required
          type="text"
          className="checkout-form-input"
          value={basicValues.name}
          onChange={onBasicChange}
          autoComplete="name"
        />
      </div>

      <div className="checkout-form-field">
        <label className="checkout-form-label" htmlFor="email">
          Email<span className="checkout-form-required">*</span>
        </label>
        <input
          id="email"
          name="email"
          required
          type="email"
          className="checkout-form-input"
          value={basicValues.email}
          onChange={onBasicChange}
          autoComplete="email"
        />
      </div>

      <div style={{ position: "absolute", left: "-9999px", opacity: 0 }}>
        <label htmlFor="website">Website</label>
        <input
          id="website"
          name="website"
          type="text"
          value={basicValues.website || ""}
          onChange={onBasicChange}
          autoComplete="off"
          tabIndex={-1}
        />
      </div>

      {/* Custom form questions */}
      {hasCustomForm && (
        <section
          className="checkout-form-extra"
          aria-label="Additional registration details"
        >
          {customQuestions.map((q) => renderQuestion(q))}
        </section>
      )}
    </>
  );
}
